import { render, staticRenderFns } from "./MetricPanel.vue?vue&type=template&id=a029aa5a&scoped=true"
import script from "./MetricPanel.vue?vue&type=script&lang=js"
export * from "./MetricPanel.vue?vue&type=script&lang=js"
import style0 from "./MetricPanel.vue?vue&type=style&index=0&id=a029aa5a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a029aa5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\oywen\\niehao\\qft\\20260317\\vue-admin-template-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a029aa5a')) {
      api.createRecord('a029aa5a', component.options)
    } else {
      api.reload('a029aa5a', component.options)
    }
    module.hot.accept("./MetricPanel.vue?vue&type=template&id=a029aa5a&scoped=true", function () {
      api.rerender('a029aa5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/core/coreMetrics/MetricPanel.vue"
export default component.exports